import Navbar from "./Navbar";
import Footer from "./Footer";
import ExitIntentPopup from "./ExitIntentPopup";
import EditModeBar from "./EditModeBar";
import LeadMagnetSection from "./LeadMagnetSection";
import CookieBanner from "./CookieBanner";

export default function PublicLayout({ children }) {
    return (
        <div className="min-h-screen flex flex-col bg-aimploy-bg">
            <Navbar />
            <main className="flex-1">
                {children}
                <LeadMagnetSection />
            </main>
            <Footer />
            <ExitIntentPopup />
            <EditModeBar />
            <CookieBanner />
        </div>
    );
}
